const getArrowClassName = (attributes) => {
  var _a;
  const placementForArrow = (_a = attributes == null ? void 0 : attributes.popper) == null ? void 0 : _a["data-popper-placement"];
  if (!placementForArrow)
    return "";
  if (placementForArrow.startsWith("top"))
    return "arrow-bottom";
  if (placementForArrow.startsWith("bottom"))
    return "arrow-top";
  if (placementForArrow.startsWith("left"))
    return "arrow-right";
  if (placementForArrow.startsWith("right"))
    return "arrow-left";
};

export { getArrowClassName };
